export default {
  brand: {
    name: "Wird",
  },
  lang: {
    zh: "中文",
    en: "EN",
  },
  header: {
    checkUpdate: "Check for updates",
    forceReload: "Hard refresh cache",
    personal: "Account",
    logout: "Sign out",
  },
  tags: {
    refresh: "Refresh",
    close: "Close",
    closeOthers: "Close others",
    closeLeft: "Close to the left",
    closeAll: "Close all",
  },
  common: {
    sendSuccess: "Sent",
  },
  login: {
    passwordLogin: "Password",
    smsLogin: "SMS code",
    adminLogin: "Admin sign in",
    wechatLogin: "WeChat QR sign in",
    bindPhone: "Bind phone number",
    username: "Username",
    password: "Password",
    phone: "Phone number",
    sms: "Verification code",
    sendCode: "Send code",
    seconds: "s",
    loginNow: "Sign in",
    bind: "Bind",
    register: "Create account",
    adminEntry: "Admin sign in",
    backUser: "Back to user sign in",
    wechatTip: "Scan with WeChat to sign in",
    backAccount: "Back to account sign in",
    thirdPartyLogin: "Other ways to sign in",
    promoSub: "Cloud control · low-code operations",
    promo1: "No coding: low-code canvas and components",
    promo2: "Modular: distributed, PoE, IP control",
    promo3: "Cloud: design, manage, and store online",
    clientDownload: "Client downloads",
    tryNow: "Try now",
  },
  register: {
    title: "Create account",
    phone: "Phone number",
    sms: "Verification code",
    password: "Set a password (at least 6 characters)",
    confirm: "Confirm password",
    submit: "Register and sign in",
    hasAccount: "Already have an account? Sign in",
    sendCode: "Send code",
    seconds: "s",
    mismatch: "Passwords do not match",
    setPassword: "Set a password",
    min6: "At least 6 characters",
  },
  menus: {
    "/homePage": "Home",
    "/uiDesign": "UI design",
    "/privateResource": "Private resources",
    "/privateResource/materials": "Materials",
    "/privateResource/directiveTypes": "Command types",
    "/privateResource/manage": "Private commands",
    "/publicResource": "Public resources",
    "/publicResource/publicDirective": "Public commands",
    "/publicResource/publicMaterial": "Public materials",
    "/projects": "Projects",
    "/helps": "Help",
    "/userManage": "Users",
    "/userManage/users": "Registered users",
    "/userManage/managers": "Admins",
    "/userManage/transferLogs": "Project transfers",
    "/userManage/canvasAiModels": "Canvas AI models",
    "/secretKeys": "License keys",
    "/secretKeys/online": "Online keys",
    "/secretKeys/local": "Local license",
    "/secretKeys/hub": "WirdHouse license",
    "/roles": "Roles",
    "/roles/list": "Role list",
    "/roles/bindMenus": "Bind menus",
    "/menus": "Menus",
    "/helpDocuments": "Help documents",
    "/templates": "Approvals",
    "/clientManage": "Clients",
    "/clientManage/apk": "APK",
    "/clientManage/qt": "QT",
    "/clientManage/mac": "Mac",
    "/clientManage/ios": "iOS",
    "/personal": "Account",
    "/homePage/moreTemplates": "More templates",
    "/projects/projectsEdit": "Project editor",
    "/projects/create": "New project",
    "/projects/add": "New project",
    "/privateResource/directiveTypes/edit": "Edit",
    "/privateResource/directiveTypes/add": "Add",
    "/privateResource/manage/edit": "Edit",
    "/privateResource/manage/add": "Add",
    "/publicResource/publicDirective/add": "Add public command",
    "/publicResource/publicDirective/edit": "Edit public command",
    "/publicResource/publicDirective/view": "View public command",
    "/clientManage/apk/add": "Add APK",
    "/clientManage/apk/edit": "Edit APK",
    "/clientManage/qt/add": "Add QT",
    "/clientManage/qt/edit": "Edit QT",
    "/clientManage/mac/add": "Add Mac",
    "/clientManage/mac/edit": "Edit Mac",
    "/clientManage/ios/add": "Add iOS",
    "/clientManage/ios/edit": "Edit iOS",
    "/helps/edit": "Details",
    "/userManage/users/edit": "Edit",
    "/userManage/managers/edit": "Edit",
    "/userManage/managers/add": "Add",
    "/menus/edit": "Edit",
    "/menus/add": "Add",
    "/helpDocuments/edit": "Edit",
    "/helpDocuments/add": "Add",
    "/client/releases": "Client release history",
  },
  clientFieldHelp: {
    upload_apk: "Upload the Android .apk. A download URL is generated for OTA and the public catalog.",
    upload_qt: "Upload Windows or Kylin installer. Windows: .exe. Kylin: match the selected CPU arch.",
    upload_mac: "Upload macOS package (.dmg / .pkg / .zip) matching the selected architecture.",
    upload_ios: "Upload the iOS .ipa.",
    channel: "Windows vs Kylin V10. Mac/iOS pages fix the platform automatically.",
    cpu_arch: "Must match the build. Windows is universal; Kylin x86/ARM; Mac Apple Silicon or Intel.",
    name: "Public version string (e.g. 1.2.0) used by OTA and the release catalog.",
    white_list_status: "When on, only whitelisted devices see this build via the OTA API.",
    white_list: "One device id per line. Used when whitelist mode is on.",
    version_log: "User-facing changelog on login download, dialog, and /client/releases.",
    status: "Join OTA (/upgrade). Yes: clients can receive this build; No: archive only, no OTA push.",
    catalog_show: "Show in the public version catalog (login download & history). Independent from OTA.",
    remark: "Extra notes shown with the changelog.",
  },
};
